import * as React from "react";

export interface LatestRequest {
    /** Starts a request; the returned check is false once a newer begin()/cancel() runs or the component unmounts. */
    begin: () => () => boolean;
    /** Invalidates any in-flight request without starting a new one. */
    cancel: () => void;
}

export function useLatestRequest(): LatestRequest {
    const latestRef = React.useRef(0);
    React.useEffect(() => () => { latestRef.current++; }, []);
    return React.useMemo(() => ({
        begin: () => {
            const id = ++latestRef.current;
            return () => id === latestRef.current;
        },
        cancel: () => { latestRef.current++; }
    }), []);
}
